// removed by extract-text-webpack-plugin
module.exports = {"table":"table__31Tq3"};


//////////////////
// WEBPACK FOOTER
// ./components/table/style.scss
// module id = lWMT
// module chunks = 13